import script from "./ProductDetail.vue?vue&type=script&setup=true&name=ProductDetail&lang=js"
export * from "./ProductDetail.vue?vue&type=script&setup=true&name=ProductDetail&lang=js"

import "./ProductDetail.vue?vue&type=style&index=0&id=334ecc7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-334ecc7c"]])

export default __exports__